import { HOUR_OPTIONS, MINUTE_OPTIONS, splitTime, joinTime } from '../../utils/time';

/* 2 selects: Hour+AM/PM combined, then Minute (00/15/30/45).
   value is a 24h "HH:MM" string. */
export default function TimePicker({ value, onChange }) {
  const { h, m } = splitTime(value);
  return (
    <div className="time-picker">
      <select value={h} onChange={(e) => onChange(joinTime(e.target.value, m))}>
        {HOUR_OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <select value={m} onChange={(e) => onChange(joinTime(h, e.target.value))}>
        {MINUTE_OPTIONS.map((o) => (
          <option key={o} value={o}>{o}</option>
        ))}
      </select>
    </div>
  );
}
